import React from 'react';
import { Card } from '@avila-tek/ui/src';
import { useQuery } from '@apollo/client';
import { Loading } from '@avila-tek/ui';
import { Title } from '../../../shared';
import { BenefitOrderResponse, Order, ShopCartItem } from '../../../../models';
import { generateShopItems } from '../../../../lib';
import { useUser } from '../../../../hooks';
import OrderItem from './OrderItem';
import ShopcartTotal from '../../../shopcart/ShopcartSummary/ShopcartTotal';
import { roles } from '../../../../static';
import { GET_DISPLAY_ORDER } from '../../../../graphql/queries';

interface OrderSummaryProps {
  order: Order;
}

function OrderSummary({ order }: OrderSummaryProps) {
  const [user] = useUser();

  // generateShopItems IS A FUNCTION TO UNIFY THE SAME SHOPCARTITEMS
  const productsShopItems = React.useMemo(
    () => generateShopItems(order, 'product'),
    [order]
  );

  const plansShopItems = React.useMemo(
    () => generateShopItems(order, 'plan'),
    [order]
  );

  // Query to fetch a single benefit structure for displaying order information
  // Only one type of benefit is available for each user in the system
  const { data: displayOrderData, loading: displayOrderLoading } = useQuery<{
    getDisplayOrder: BenefitOrderResponse;
  }>(GET_DISPLAY_ORDER, {
    variables: {
      data: {
        _id: order?._id,
      },
    },
    fetchPolicy: 'network-only',
  });
  const benefitsShopItems = [displayOrderData?.getDisplayOrder];

  const getQuantity = (item: ShopCartItem) =>
    item.shopList.reduce((acc, cur) => acc + cur.quantity, 0);

  if (displayOrderLoading) return <Loading />;

  return (
    <Card className="p-4 sm:px-6 relative">
      <Title title="Resumen" />

      {productsShopItems?.length > 0
        ? productsShopItems?.map((item) => (
            <OrderItem
              key={item.title}
              title={item.title}
              price={item.price}
              quantity={getQuantity(item)}
              subtitle="Producto"
              photoSrc={item.photo}
              shopCartItem={item}
              clients={item.shopList}
              comparateAtPrice={item.compareAtPrice}
            />
          ))
        : null}

      {benefitsShopItems.length > 0 && user?.userType !== roles.ally
        ? benefitsShopItems?.map((item) => (
            <OrderItem
              key={item.title}
              title={item.title}
              price={item?.price}
              quantity={getQuantity(item)}
              subtitle="Beneficio"
              photoSrc=""
              clients={item.shopList}
              shopCartItem={item}
            />
          ))
        : null}

      {plansShopItems.length > 0 && user?.userType !== roles.ally
        ? plansShopItems?.map((item) => (
            <OrderItem
              key={item.title}
              title={item?.title}
              price={item?.price}
              quantity={getQuantity(item)}
              subtitle="Subcripción"
              photoSrc=""
              clients={item.shopList}
              shopCartItem={item}
            />
          ))
        : null}
      {user?.userType !== roles.ally ? (
        <ShopcartTotal
          total={{
            subtotal: order.subTotal,
            totalTax: order.taxTotal,
            total: order.total,
            discountTotal: order.discountTotal,
          }}
        />
      ) : null}
    </Card>
  );
}

export default OrderSummary;
